import {match, Pattern} from 'ts-pattern';

import {isNotNil} from 'ramda';

import type {DataGridRow} from '@dms/api/core';

import type {CustomerInsightsAlert} from '../types/CustomerInsightsViewModel';
import {CUSTOMER_INSIGHTS_GRID_FIELDS} from './customerInsightsGridFields';
import {readDataGridCellDateString} from './readDataGridCellDateString';
import {readDataGridCellMoney} from './readDataGridCellMoney';
import {readDataGridCellString} from './readDataGridCellString';

export function mapCustomerInsightsAlert(
  row: DataGridRow | undefined,
  kind: CustomerInsightsAlert['kind'],
  href?: string
): CustomerInsightsAlert | undefined {
  return match(row)
    .with(Pattern.nullish, () => undefined)
    .with(Pattern.nonNullable, (availableRow) => {
      const title = match(kind)
        .with('overdueInvoices', () =>
          readDataGridCellString(availableRow, CUSTOMER_INSIGHTS_GRID_FIELDS.overdueInvoices.code)
        )
        .with('overdueTasks', () =>
          readDataGridCellString(availableRow, CUSTOMER_INSIGHTS_GRID_FIELDS.overdueTasks.code)
        )
        .exhaustive();

      return match(title)
        .with(undefined, () => undefined)
        .with(Pattern.string, (availableTitle) => {
          const amount = match(kind)
            .with('overdueInvoices', () =>
              readDataGridCellMoney(
                availableRow,
                CUSTOMER_INSIGHTS_GRID_FIELDS.overdueInvoices.amount
              )
            )
            .with('overdueTasks', () => undefined)
            .exhaustive();

          return {
            kind,
            id: availableRow.id,
            title: availableTitle,
            dueAt: readDataGridCellDateString(
              availableRow,
              CUSTOMER_INSIGHTS_GRID_FIELDS[kind].occurredAt
            ),
            ...(isNotNil(amount) ? {amount} : {}),
            ...(isNotNil(href) ? {href} : {}),
          };
        })
        .exhaustive();
    })
    .exhaustive();
}
